const login = r =>
  require.ensure([], () => r(require("../components/login.vue")), "login");
const home = r =>
  require.ensure([], () => r(require("../components/home.vue")), "home");
const index = r =>
  require.ensure(
    [],
    () => r(require("../components/homePage/index.vue")),
    "index"
  );

// 系统管理
const adMinistrator = r =>
  require.ensure(
    [],
    () => r(require("../components/systemManagement/adMinistrator.vue")),
    "adMinistrator"
  );
const systemset = r =>
  require.ensure(
    [],
    () => r(require("../components/systemManagement/systemset.vue")),
    "systemset"
  );
const menu = r =>
  require.ensure(
    [],
    () => r(require("../components/systemManagement/menu.vue")),
    "menu"
  );
const loginManagement = r =>
  require.ensure(
    [],
    () => r(require("../components/systemManagement/loginManagement.vue")),
    "loginManagement"
  );
const roleManagement = r =>
  require.ensure(
    [],
    () => r(require("../components/systemManagement/roleManagement.vue")),
    "roleManagement"
  );

// 系统设置
const userManagement = r =>
  require.ensure(
    [],
    () =>
      r(require("../views/systemSettings/userManagement/userManagement.vue")),
    "userManagement"
  );
const realNameInfoInquire = r =>
  require.ensure(
    [],
    () =>
      r(
        require("../views/systemSettings/userManagement/realNameInfoInquire.vue")
      ),
    "realNameInfoInquire"
  );
const riskUsers = r =>
  require.ensure(
    [],
    () => r(require("../views/systemSettings/userManagement/riskUsers.vue")),
    "riskUsers"
  );

const sensitiveManagement = r =>
  require.ensure(
    [],
    () => r(require("../views/systemSettings/sensitiveManagement.vue")),
    "sensitiveManagement"
  );
const groupManagement = r =>
  require.ensure(
    [],
    () =>
      r(require("../views/systemSettings/groupManagement/groupManagement.vue")),
    "groupManagement"
  );
const versionManagement = r =>
  require.ensure(
    [],
    () =>
      r(
        require("../views/systemSettings/versionManagement/versionManagement.vue")
      ),
    "versionManagement"
  );
const systemParamManagement = r =>
  require.ensure(
    [],
    () =>
      r(
        require("../views/systemSettings/systemParamManagement/systemParamManagement.vue")
      ),
    "systemParamManagement"
  );
const whitelistManagement = r =>
  require.ensure(
    [],
    () =>
      r(
        require("../views/systemSettings/whitelistManagement/whitelistManagement.vue")
      ),
    "whitelistManagement"
  );

const FirstimageManagement = r =>
  require.ensure(
    [],
    () => r(require("../views/systemSettings/FirstimageManagement/index.vue")),
    "FirstimageManagement"
  );
const pcFirstimageManagement = r =>
  require.ensure(
    [],
    () =>
      r(require("../views/systemSettings/pcFirstimageManagement/index.vue")),
    "pcFirstimageManagement"
  );

// 投诉管理
const userComplaints = r =>
  require.ensure(
    [],
    () =>
      r(
        require("../views/complaintManagement/userComplaints/userComplaints.vue")
      ),
    "userComplaints"
  );
const groupComplaints = r =>
  require.ensure(
    [],
    () =>
      r(
        require("../views/complaintManagement/groupComplaints/groupComplaints.vue")
      ),
    "groupComplaints"
  );
const transactionComplaints = r =>
  require.ensure(
    [],
    () => r(require("../views/complaintManagement/transaction/index.vue")),
    "transaction"
  );

// 消息管理
const userMessageManagement = r =>
  require.ensure(
    [],
    () =>
      r(
        require("../views/messageManagement/userMessageManagement/userMessageManagement.vue")
      ),
    "userMessageManagement"
  );
const groupMessageManagement = r =>
  require.ensure(
    [],
    () =>
      r(
        require("../views/messageManagement/groupMessageManagement/groupMessageManagement.vue")
      ),
    "groupMessageManagement"
  );
const broadcastMessage = r =>
  require.ensure(
    [],
    () => r(require("../views/messageManagement/broadcastMessage.vue")),
    "broadcastMessage"
  );
const massMessaging = r =>
  require.ensure(
    [],
    () => r(require("../views/messageManagement/massMessaging.vue")),
    "massMessaging"
  );
// 社群管理（频道 + 讨论群组）
const circleList = r =>
  require.ensure(
    [],
    () => r(require("../views/circleManagement/list.vue")),
    "circleList"
  );
const circleDetail = r =>
  require.ensure(
    [],
    () => r(require("../views/circleManagement/detail.vue")),
    "circleDetail"
  );
const circleOwnerAudit = r =>
  require.ensure(
    [],
    () => r(require("../views/circleManagement/ownerAudit.vue")),
    "circleOwnerAudit"
  );
const circlePostAudit = r =>
  require.ensure(
    [],
    () => r(require("../views/circleManagement/postAudit.vue")),
    "circlePostAudit"
  );
// 在线客服
const csDesk = r =>
  require.ensure(
    [],
    () => r(require("../views/customerService/desk.vue")),
    "csDesk"
  );
const csSessionHistory = r =>
  require.ensure(
    [],
    () => r(require("../views/customerService/sessionHistory.vue")),
    "csSessionHistory"
  );
const csConfig = r =>
  require.ensure(
    [],
    () => r(require("../views/customerService/config.vue")),
    "csConfig"
  );
// 仟信豆提现
const beanWithdrawList = r =>
  require.ensure(
    [],
    () => r(require("../views/beanWithdraw/list.vue")),
    "beanWithdrawList"
  );
// 费率配置
const feeConfigGlobal = r =>
  require.ensure(
    [],
    () => r(require("../views/feeConfig/global.vue")),
    "feeConfigGlobal"
  );
// 云端审核
const cloudAuditConfig = r =>
  require.ensure(
    [],
    () => r(require("../views/cloudAudit/configList.vue")),
    "cloudAuditConfig"
  );
const cloudAuditLib = r =>
  require.ensure(
    [],
    () => r(require("../views/cloudAudit/libList.vue")),
    "cloudAuditLib"
  );
const cloudAuditWords = r =>
  require.ensure(
    [],
    () => r(require("../views/cloudAudit/wordList.vue")),
    "cloudAuditWords"
  );
// 操作审计
const operationHistory = r =>
  require.ensure(
    [],
    () => r(require("../views/operationAudit/operationHistory.vue")),
    "operationHistory"
  );
const operationLogConfig = r =>
  require.ensure(
    [],
    () => r(require("../views/operationAudit/operationLogConfig.vue")),
    "operationLogConfig"
  );
// 用户视频认证
const userVerifyVideo = r =>
  require.ensure(
    [],
    () => r(require("../views/userVerifyVideo/list.vue")),
    "userVerifyVideo"
  );
// 钱包风控配置
const walletRiskScene = r =>
  require.ensure(
    [],
    () => r(require("../views/walletRisk/scene.vue")),
    "walletRiskScene"
  );
const walletRiskRule = r =>
  require.ensure(
    [],
    () => r(require("../views/walletRisk/rule.vue")),
    "walletRiskRule"
  );
const walletRiskGlobal = r =>
  require.ensure(
    [],
    () => r(require("../views/walletRisk/global.vue")),
    "walletRiskGlobal"
  );
const walletRiskLimit = r =>
  require.ensure(
    [],
    () => r(require("../views/walletRisk/limit.vue")),
    "walletRiskLimit"
  );
const walletRiskCheckLog = r =>
  require.ensure(
    [],
    () => r(require("../views/walletRisk/checkLog.vue")),
    "walletRiskCheckLog"
  );
const walletRiskConfigLog = r =>
  require.ensure(
    [],
    () => r(require("../views/walletRisk/configLog.vue")),
    "walletRiskConfigLog"
  );
// 风险消息
const riskMessageManagement = r =>
  require.ensure(
    [],
    () =>
      r(require("../views/messageManagement/riskMessageManagement/index.vue")),
    "riskMessageManagement"
  );
//权限冻结
const limitscontrol = r =>
  require.ensure(
    [],
    () => r(require("../views/riskcontrol/limitscontrol/index.vue")),
    "limitscontrol"
  );
const controllimits = r =>
  require.ensure(
    [],
    () => r(require("../views/riskcontrol/controllimits/index.vue")),
    "controllimits"
  );
// 风控核查案例
const riskCase = r =>
  require.ensure(
    [],
    () => r(require("../views/riskcontrol/case/index.vue")),
    "riskCase"
  );
// 黑名单
const blacklist = r =>
  require.ensure(
    [],
    () => r(require("../views/riskcontrol/blacklist/index.vue")),
    "blacklist"
  );
// 黑名单
const AIface = r =>
  require.ensure(
    [],
    () => r(require("../views/riskcontrol/AIface/index.vue")),
    "AIface"
  );
const chatReview = r =>
  require.ensure(
    [],
    () => r(require("../views/riskcontrol/chatReview.vue")),
    "chatReview"
  );
const userfreeze = r =>
  require.ensure(
    [],
    () => r(require("../views/riskcontrol/userfreeze/index.vue")),
    "userfreeze"
  );
const transactionfreeze = r =>
  require.ensure(
    [],
    () => r(require("../views/riskcontrol/transactionfreeze/index.vue")),
    "transactionfreeze"
  );
// 风险图片
const picMessageManagement = r =>
  require.ensure(
    [],
    () =>
      r(require("../views/messageManagement/picMessageManagement/index.vue")),
    "picMessageManagement"
  );
const announcementManagement = r =>
  require.ensure(
    [],
    () =>
      r(require("../views/messageManagement/announcementManagement/index.vue")),
    "announcementManagement"
  );
// 新闻动态
const newsupdates = r =>
  require.ensure(
    [],
    () => r(require("../views/operation/newsupdates/index.vue")),
    "newsupdates"
  );

// 靓号类型管理
const lianghaoTypeManagement = r =>
  require.ensure(
    [],
    () =>
      r(
        require("../views/lianghaoManagement/lianghaoTypeManagement/lianghaoTypeManagement.vue")
      ),
    "lianghaoTypeManagement"
  );
const lianghaoManagement = r =>
  require.ensure(
    [],
    () =>
      r(
        require("../views/lianghaoManagement/lianghaoManagement/lianghaoManagement.vue")
      ),
    "lianghaoManagement"
  );
const purchasedLianghaoManagement = r =>
  require.ensure(
    [],
    () =>
      r(require("../views/lianghaoManagement/purchasedLianghaoManagement.vue")),
    "purchasedLianghaoManagement"
  );

// 订单管理（新：靓号/会员/仟信币购买订单）
const prettyOrder = r =>
  require.ensure(
    [],
    () => r(require("../views/order/prettyOrder.vue")),
    "prettyOrder"
  );
const vipOrder = r =>
  require.ensure(
    [],
    () => r(require("../views/order/vipOrder.vue")),
    "vipOrder"
  );
const coinOrder = r =>
  require.ensure(
    [],
    () => r(require("../views/order/coinOrder.vue")),
    "coinOrder"
  );

// 订单管理（旧页，兼容历史菜单）
const lianghaoOrderManagement = r =>
  require.ensure(
    [],
    () => r(require("../views/orderManagement/lianghaoOrderManagement.vue")),
    "lianghaoOrderManagement"
  );
const memberOrderManagement = r =>
  require.ensure(
    [],
    () => r(require("../views/orderManagement/memberOrderManagement.vue")),
    "memberOrderManagement"
  );

// 会员管理
const membershipPrivileges = r =>
  require.ensure(
    [],
    () =>
      r(
        require("../views/memberManagement/membershipPrivileges/membershipPrivileges.vue")
      ),
    "membershipPrivileges"
  );
const membermanagement = r =>
  require.ensure(
    [],
    () =>
      r(
        require("../views/memberManagement/membermanagement/membermanagement.vue")
      ),
    "membermanagement"
  );

// 钱包管理
const identityBlackManagement = r =>
  require.ensure(
    [],
    () => r(require("../views/walletManagement/identityBlackManagement.vue")),
    "identityBlackManagement"
  );
const billManagement = r =>
  require.ensure(
    [],
    () => r(require("../views/walletManagement/billManagement.vue")),
    "billManagement"
  );
const withdrawalManagement = r =>
  require.ensure(
    [],
    () =>
      r(
        require("../views/walletManagement/withdrawalManagement/withdrawalManagement.vue")
      ),
    "withdrawalManagement"
  );
const bankCardManagement = r =>
  require.ensure(
    [],
    () => r(require("../views/walletManagement/bankCardManagement.vue")),
    "bankCardManagement"
  );
const withdrawalreview = r =>
  require.ensure(
    [],
    () => r(require("../views/walletManagement/withdrawalreview.vue")),
    "withdrawalreview"
  );
const transferRedEnvelopeManagement = r =>
  require.ensure(
    [],
    () =>
      r(require("../views/walletManagement/transferRedEnvelopeManagement.vue")),
    "transferRedEnvelopeManagement"
  );
const ComeBackMoney = r =>
  require.ensure(
    [],
    () => r(require("../views/walletManagement/ComeBackMoney/index.vue")),
    "ComeBackMoney"
  );

const merchantbill = r =>
  require.ensure(
    [],
    () => r(require("../views/walletManagement/merchantbill/index.vue")),
    "merchantbill"
  );
const Ledgerjournal = r =>
  require.ensure(
    [],
    () => r(require("../views/walletManagement/Ledgerjournal/index.vue")),
    "Ledgerjournal"
  );

//进件
const IncomingInterface = r =>
  require.ensure(
    [],
    () => r(require("../views/walletManagement/IncomingInterface.vue")),
    "IncomingInterface"
  );

// 商品管理
// const commodityManagement = r => require.ensure([], () => r(require('../views/commodityManagement/auditCenter.vue')), 'commodityManagement');
const auditCenter = r =>
  require.ensure(
    [],
    () =>
      r(require("../views/commodityManagement/auditCenter/auditCenter.vue")),
    "auditCenter"
  );
const orderGoods = r =>
  require.ensure(
    [],
    () => r(require("../views/commodityManagement/orderGoods/orderGoods.vue")),
    "orderGoods"
  );
// 商户管理
const merchant = r =>
  require.ensure(
    [],
    () => r(require("../views/merchantManagement/merchant/index.vue")),
    "merchant"
  );
const merchantManagement = r =>
  require.ensure(
    [],
    () =>
      r(require("../views/merchantManagement/merchantManagement/index.vue")),
    "merchantManagement"
  );
const transactionbill = r =>
  require.ensure(
    [],
    () => r(require("../views/merchantManagement/transactionbill/index.vue")),
    "transactionbill"
  );
const usertransactions = r =>
  require.ensure(
    [],
    () => r(require("../views/merchantManagement/usertransactions/index.vue")),
    "usertransactions"
  );
const withdrawalrecords = r =>
  require.ensure(
    [],
    () => r(require("../views/merchantManagement/withdrawalrecords/index.vue")),
    "withdrawalrecords"
  );

// //配置路由
let routes = [
  { path: "/", redirect: "/login", name: "", hidden: true },
  { path: "/login", component: login, name: "", hidden: true },
  {
    path: "/homePage",
    component: home,
    name: "首页",
    redirect: "/homePage/index",
    iconCls: "el-icon-s-home",
    children: [{ path: "/homePage/index", component: index, name: "首页" }]
  },
  {
    path: "/userManage",
    component: home,
    name: "用户管理",
    redirect: "/userManage/userManagement",
    iconCls: "el-icon-s-custom", //图标样式class
    children: [
      {
        path: "/userManage/userManagement",
        component: userManagement,
        name: "用户列表"
      },
      {
        path: "/userManage/realNameInfoInquire",
        component: realNameInfoInquire,
        name: "实名信息查询"
      },
      { path: "/userManage/riskUsers", component: riskUsers, name: "风险用户" },
      {
        path: "/userManage/usertransactions",
        component: usertransactions,
        name: "交易记录"
      }
    ]
  },
  {
    path: "/groupManagement",
    component: home,
    name: "群组管理",
    redirect: "/groupManagement/groupList",
    iconCls: "el-icon-coordinate", //图标样式class
    children: [
      {
        path: "/groupManagement/groupList",
        component: groupManagement,
        name: "群组列表"
      }
    ]
  },
  {
    path: "/circle",
    component: home,
    name: "社群管理",
    redirect: "/circle/list",
    iconCls: "el-icon-connection",
    children: [
      {
        path: "/circle/list",
        component: circleList,
        name: "频道列表"
      },
      {
        path: "/circle/ownerAudit",
        component: circleOwnerAudit,
        name: "频道主内容审核"
      },
      {
        path: "/circle/postAudit",
        component: circlePostAudit,
        name: "频道帖子审核"
      },
      {
        path: "/circle/detail",
        component: circleDetail,
        name: "频道详情",
        hidden: true
      }
    ]
  },
  {
    path: "/bean",
    component: home,
    name: "仟信豆",
    redirect: "/bean/withdraw/list",
    iconCls: "el-icon-coin",
    children: [
      {
        path: "/bean/withdraw/list",
        component: beanWithdrawList,
        name: "仟信豆提现"
      }
    ]
  },
  {
    path: "/fee",
    component: home,
    name: "费率",
    redirect: "/fee/global",
    iconCls: "el-icon-s-data",
    children: [
      {
        path: "/fee/global",
        component: feeConfigGlobal,
        name: "费率配置"
      }
    ]
  },
  {
    path: "/cloud-audit",
    component: home,
    name: "云端审核",
    redirect: "/cloud-audit/config",
    iconCls: "el-icon-view",
    children: [
      {
        path: "/cloud-audit/config",
        component: cloudAuditConfig,
        name: "审核配置"
      },
      {
        path: "/cloud-audit/lib",
        component: cloudAuditLib,
        name: "词库管理"
      },
      {
        path: "/cloud-audit/words",
        component: cloudAuditWords,
        name: "屏蔽词"
      }
    ]
  },
  {
    path: "/system/operationAudit",
    component: home,
    name: "操作审计",
    redirect: "/system/operationHistory",
    iconCls: "el-icon-document",
    children: [
      {
        path: "/system/operationHistory",
        component: operationHistory,
        name: "用户操作记录"
      },
      {
        path: "/system/operationLogConfig",
        component: operationLogConfig,
        name: "操作记录配置"
      }
    ]
  },
  {
    path: "/user",
    component: home,
    name: "用户认证",
    redirect: "/user/verifyVideo",
    iconCls: "el-icon-video-camera",
    children: [
      {
        path: "/user/verifyVideo",
        component: userVerifyVideo,
        name: "用户视频认证"
      }
    ]
  },
  {
    path: "/risk",
    component: home,
    name: "钱包风控",
    redirect: "/risk/scene",
    iconCls: "el-icon-warning",
    children: [
      {
        path: "/risk/scene",
        component: walletRiskScene,
        name: "场景开关"
      },
      {
        path: "/risk/rule",
        component: walletRiskRule,
        name: "规则管理"
      },
      {
        path: "/risk/global",
        component: walletRiskGlobal,
        name: "全局参数"
      },
      {
        path: "/risk/limit",
        component: walletRiskLimit,
        name: "限额管理"
      },
      {
        path: "/risk/checkLog",
        component: walletRiskCheckLog,
        name: "校验日志"
      },
      {
        path: "/risk/configLog",
        component: walletRiskConfigLog,
        name: "配置审计"
      }
    ]
  },
  {
    path: "/cs",
    component: home,
    name: "在线客服",
    redirect: "/cs/desk",
    iconCls: "el-icon-service",
    children: [
      {
        path: "/cs/desk",
        component: csDesk,
        name: "客服工作台"
      },
      {
        path: "/cs/sessionHistory",
        component: csSessionHistory,
        name: "会话记录"
      },
      {
        path: "/cs/config",
        component: csConfig,
        name: "渠道与坐席"
      }
    ]
  },
  {
    path: "/systemSettings",
    component: home,
    name: "系统设置",
    redirect: "/systemSettings/sensitiveManagement",
    iconCls: "el-icon-setting", //图标样式class
    children: [
      {
        path: "/systemSettings/sensitiveManagement",
        component: sensitiveManagement,
        name: "敏感词汇管理"
      },
      {
        path: "/systemSettings/versionManagement",
        component: versionManagement,
        name: "APP版本管理"
      },
      {
        path: "/systemSettings/systemParamManagement",
        component: systemParamManagement,
        name: "系统参数管理"
      },
      {
        path: "/systemSettings/whitelistManagement",
        component: whitelistManagement,
        name: "白名单管理"
      },
      {
        path: "/systemSettings/FirstimageManagement",
        component: FirstimageManagement,
        name: "app首屏管理"
      },
      {
        path: "/systemSettings/pcFirstimageManagement",
        component: pcFirstimageManagement,
        name: "pc首屏管理"
      }
    ]
  },
  {
    path: "/systemManagement",
    component: home,
    name: "运营平台管理",
    redirect: "/systemManagement/systemset",
    iconCls: "el-icon-setting", //图标样式class
    children: [
      // { path: '/systemManagement/systemset', component: systemset, name: '系统设置'},
      {
        path: "/systemManagement/adMinistrator",
        component: adMinistrator,
        name: "用户管理"
      },
      { path: "/systemManagement/menu", component: menu, name: "菜单管理" },
      {
        path: "/systemManagement/loginManagement",
        component: loginManagement,
        name: "登录管理"
      },
      {
        path: "/systemManagement/roleManagement",
        component: roleManagement,
        name: "角色管理"
      },
      {
        path: "/systemManagement/sensitiveManagement",
        component: sensitiveManagement,
        name: "敏感词汇管理"
      }
    ]
  },
  {
    path: "/complaintManagement",
    component: home,
    name: "投诉管理",
    redirect: "/complaintManagement/userComplaints",
    iconCls: "el-icon-edit", //图标样式class
    children: [
      {
        path: "/complaintManagement/userComplaints",
        component: userComplaints,
        name: "用户投诉信息"
      },
      {
        path: "/complaintManagement/groupComplaints",
        component: groupComplaints,
        name: "群投诉信息"
      },
      {
        path: "/complaintManagement/transaction",
        component: transactionComplaints,
        name: "交易投诉"
      }
    ]
  },
  {
    path: "/messageManagement",
    component: home,
    name: "消息管理",
    redirect: "/messageManagement/userMessageManagement",
    iconCls: "el-icon-chat-dot-square", //图标样式class
    children: [
      {
        path: "/messageManagement/userMessageManagement",
        component: userMessageManagement,
        name: "用户消息管理"
      },
      {
        path: "/messageManagement/groupMessageManagement",
        component: groupMessageManagement,
        name: "群消息管理"
      },
      {
        path: "/messageManagement/broadcastMessage",
        component: broadcastMessage,
        name: "广播消息"
      },
      {
        path: "/messageManagement/massMessaging",
        component: massMessaging,
        name: "群发消息"
      }
    ]
  },
  {
    path: "/lianghaoManagement",
    component: home,
    name: "靓号管理",
    redirect: "/lianghaoManagement/lianghaoTypeManagement",
    iconCls: "el-icon-document-copy", //图标样式class
    children: [
      {
        path: "/lianghaoManagement/lianghaoTypeManagement",
        component: lianghaoTypeManagement,
        name: "靓号类型管理"
      },
      {
        path: "/lianghaoManagement/lianghaoManagement",
        component: lianghaoManagement,
        name: "靓号管理"
      },
      {
        path: "/lianghaoManagement/purchasedLianghaoManagement",
        component: purchasedLianghaoManagement,
        name: "已购买靓号管理"
      }
    ]
  },
  {
    path: "/order",
    component: home,
    name: "订单管理",
    redirect: "/order/pretty",
    iconCls: "el-icon-shopping-cart-full",
    children: [
      {
        path: "/order/pretty",
        component: prettyOrder,
        name: "靓号购买订单"
      },
      {
        path: "/order/vip",
        component: vipOrder,
        name: "会员购买订单"
      },
      {
        path: "/order/coin",
        component: coinOrder,
        name: "仟信币购买订单"
      }
    ]
  },
  {
    path: "/orderManagement",
    component: home,
    name: "订单管理(旧)",
    redirect: "/orderManagement/lianghaoOrderManagement",
    iconCls: "el-icon-shopping-cart-full",
    children: [
      {
        path: "/orderManagement/lianghaoOrderManagement",
        component: lianghaoOrderManagement,
        name: "靓号订单管理"
      },
      {
        path: "/orderManagement/memberOrderManagement",
        component: memberOrderManagement,
        name: "会员订单管理"
      }
    ]
  },
  {
    path: "/memberManagement",
    component: home,
    name: "会员管理",
    redirect: "/memberManagement/membershipPrivileges",
    iconCls: "el-icon-monitor", //图标样式class
    children: [
      {
        path: "/memberManagement/membershipPrivileges",
        component: membershipPrivileges,
        name: "会员特权"
      },
      {
        path: "/memberManagement/membermanagement",
        component: membermanagement,
        name: "会员管理"
      }
    ]
  },
  {
    path: "/walletManagement",
    component: home,
    name: "钱包管理",
    redirect: "/walletManagement/identityBlackManagement",
    iconCls: "el-icon-bank-card", //图标样式class
    children: [
      {
        path: "/walletManagement/identityBlackManagement",
        component: identityBlackManagement,
        name: "身份黑名单管理"
      },
      {
        path: "/walletManagement/billManagement",
        component: billManagement,
        name: "账单管理"
      },
      {
        path: "/walletManagement/withdrawalManagement",
        component: withdrawalManagement,
        name: "提现管理"
      },
      {
        path: "/walletManagement/bankCardManagement",
        component: bankCardManagement,
        name: "银行卡管理"
      },
      {
        path: "/walletManagement/transferRedEnvelopeManagement",
        component: transferRedEnvelopeManagement,
        name: "转账红包管理"
      },
      {
        path: "/walletManagement/ComeBackMoney",
        component: ComeBackMoney,
        name: "退款记录"
      },
      {
        path: "/walletManagement/merchantbill",
        component: merchantbill,
        name: "商户对账单管理"
      },
      {
        path: "/walletManagement/Ledgerjournal",
        component: Ledgerjournal,
        name: "分账流水管理"
      },
      {
        path: "/walletManagement/IncomingInterface",
        component: IncomingInterface,
        name: "进件管理"
      },
      {
        path: "/walletManagement/withdrawalreview",
        component: withdrawalreview,
        name: "提现审核"
      }
    ]
  },
  // 商品管理
  {
    path: "/commodityManagement",
    component: home,
    name: "商品管理",
    redirect: "/",
    iconCls: "el-icon-bank-card",
    children: [
      {
        path: "/commodityManagement/auditCenter",
        component: auditCenter,
        name: "用户中心"
      },
      {
        path: "/commodityManagement/orderGoods",
        component: orderGoods,
        name: "订单中心"
      }
    ]
  },
  {
    path: "/merchantManagement",
    component: home,
    name: "商户管理",
    redirect: "/",
    iconCls: "el-icon-bank-card",
    children: [
      {
        path: "/merchantManagement/merchant",
        component: merchant,
        name: "待审核商户"
      },
      {
        path: "/merchantManagement/merchantManagement",
        component: merchantManagement,
        name: "商户管理"
      },
      {
        path: "/merchantManagement/transactionbill",
        component: transactionbill,
        name: "交易记录"
      },
      {
        path: "/merchantManagement/withdrawalrecords",
        component: withdrawalrecords,
        name: "提现记录"
      }
    ]
  },
  // 风控中心
  {
    path: "/riskcontrol",
    component: home,
    name: "风控中心",
    redirect: "/",
    iconCls: "el-icon-bank-card",
    children: [
      {
        path: "/riskcontrol/riskMessageManagement",
        component: riskMessageManagement,
        name: "风险消息"
      },
      {
        path: "/riskcontrol/picMessageManagement",
        component: picMessageManagement,
        name: "风险图片"
      },
      {
        path: "/riskcontrol/limitscontrol",
        component: limitscontrol,
        name: "权限冻结"
      },
      {
        path: "/riskcontrol/transactionfreeze",
        component: transactionfreeze,
        name: "交易冻结"
      },
      {
        path: "/riskcontrol/controllimits",
        component: controllimits,
        name: "冻结权限"
      },
      {
        path: "/riskcontrol/case",
        component: riskCase,
        name: "\u98ce\u63a7\u6838\u67e5\u6848\u4f8b"
      },
      {
        path: "/riskcontrol/chatReview",
        component: chatReview,
        name: "客户聊天审查"
      },
      {
        path: "/riskcontrol/blacklist",
        component: blacklist,
        name: "黑名单管理"
      },
      {
        path: "/riskcontrol/AIface",
        component: AIface,
        name: "AI换脸拦截"
      }
      // {
      //   path: "/riskcontrol/userfreeze",
      //   component: userfreeze,
      //   name: "冻结记录"
      // }
    ]
  },
  {
    path: "/operation",
    component: home,
    name: "运营中心",
    redirect: "/",
    iconCls: "el-icon-bank-card",
    children: [
      {
        path: "/messageManagement/announcementManagement",
        component: announcementManagement,
        name: "公告文章"
      },
      {
        path: "/operation/newsupdates",
        component: newsupdates,
        name: "新闻动态"
      }
    ]
  }
];

export default {
  routes: routes
};



// WEBPACK FOOTER //
// ./src/oos/router/index.js